import axios from "axios";
import fileDownload from "js-file-download";
import AuthManager from "../oidc/index";
import { toastMessage } from "../utility";

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 60000,
  decompress: true,
  responseType: "json",
});
httpClient.interceptors.request.use(
  (config) => {
    const token = AuthManager.getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["Content-Type"] = "application/json";
    config.headers["Accept-Language"] = "tr";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      return AuthManager.login();
    }
    if (error.response.status === 403) {
      errorHandler(error, "Bu işleme yetkiniz yok.", "Yetki Hatası");
    }
    if (error.response.status === 400) {
      let traceId = error.response.data.traceId;
      let msg = '';
      if (error.response.data.errors[0].errorType === "ValidationError") {
        error.response.data.errors.map((t: any) =>
          msg += `Mesaj: ${t.errorDesc} <br /> Alan: ${t.propertyDisplayName} <br /><br />`);
      }
      if(error.response.data.errors[0].errorType === "BusinessError"){
        errorHandler(error, error.response.data.errors[0].errorDesc, "Hatalı İstek");
      }
      msg += `İzleme Numarası: ${traceId}`;

      errorHandler(error, msg, "Hatalı İstek");
    }
    return Promise.reject(error);
  }
);

const errorHandler = (err: any, msg?: string, title?: string) => {
  toastMessage({
    messageType: 'error',
    title: title ?? "Hata",
    message: msg ?? "Hata oluştu",
    timeout: 15000,
  });
}

const get = async <T>(
  endpoint: string,
  successMessage: "",
  spinnerElementId = undefined,
  doNotShowToastr = false
): Promise<T> => {
  if (spinnerElementId) {
    // spinnerService.show(spinnerElementId);
  }
  let response: any = null;
  await httpClient
    .get<T>(endpoint)
    .then((res) => {
      response = res.data;
      //successHandler(successMessage, doNotShowToastr);
    })
    .catch((err) => {
      //response = errorHandler(err, doNotShowToastr);
    })
    .finally(() => {
      if (spinnerElementId) {
        // spinnerService.hide(spinnerElementId);
      }
    });
  return response;
};

//   const put = async <T>(
//     endpoint: string,
//     body: any,
//     successMessage: string = undefined,
//     spinnerElementId = undefined,
//     doNotShowToastr = false,
//   ): Promise<ServiceResponse<T>> => {
//     if (spinnerElementId) {
//       // spinnerService.show(spinnerElementId);
//     }
//     let response = null;
//     await httpClient
//       .put(endpoint, body)
//       .then(res => {
//         response = res.data;
//         successHandler(successMessage, doNotShowToastr);
//       })
//       .catch(err => {
//         response = errorHandler(err, doNotShowToastr);
//       })
//       .finally(() => {
//         if (spinnerElementId) {
//           // spinnerService.hide(spinnerElementId);
//         }
//       });
//     return response;
//   };

const post = async <T>(
  endpoint: string,
  body: any,
  successMessage: string = "",
  spinnerElementId = undefined,
  doNotShowToastr = false
): Promise<T> => {
  if (spinnerElementId) {
    // spinnerService.show(spinnerElementId);
  }
  let response: any = null;
  await httpClient
    .post<T>(endpoint, body)
    .then((res) => {
      response = res.data;
      //successHandler(successMessage, doNotShowToastr);
    })
    .catch((err) => {
      //response = errorHandler(err, doNotShowToastr);
    })
    .finally(() => {
      if (spinnerElementId) {
        // spinnerService.hide(spinnerElementId);
      }
    });
  return response;
};

//   const del = async (
//     endpoint: string,
//     successMessage: string = undefined,
//     spinnerElementId = undefined,
//     doNotShowToastr = false,
//   ): Promise<ServiceResponse> => {
//     if (spinnerElementId) {
//       // spinnerService.show(spinnerElementId);
//     }
//     let response = null;
//     await httpClient
//       .delete(endpoint)
//       .then(res => {
//         response = '';
//         successHandler(successMessage, doNotShowToastr);
//       })
//       .catch(err => {
//         response = errorHandler(err, doNotShowToastr);
//       })
//       .finally(() => {
//         if (spinnerElementId) {
//           // spinnerService.hide(spinnerElementId);
//         }
//       });
//     return response;
//   };

const exportToExcel = async (
  endpoint: string,
  body: any
): Promise<void> => {

  await httpClient
    .post(endpoint, body, { responseType: "blob" })
    .then((res) => {
      let filename = "";
      const contentDispositionHeader = res.headers["content-disposition"];
      const arr = contentDispositionHeader.split(";");
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].indexOf("filename*=") > 0) {
          filename = decodeURIComponent(arr[i].split("UTF-8''")[1]);
          break;
        }
      }
      fileDownload(res.data, filename);
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {

    });
};

export { get, post, exportToExcel };
